// extracted by mini-css-extract-plugin
export default {"recipeInfoCell":"HAGKdeXSviAlA7pCFPzi","description":"Q4S7OLPYoa0szKu2Nevv","box":"unr0oJS3T4Nk3VLu5brr","recipeRow":"o11o2xk3rYC2UnswGvVE"};